import { render, staticRenderFns } from "./user_shop_bundle_record.vue?vue&type=template&id=e095089a"
import script from "./user_shop_bundle_record.vue?vue&type=script&lang=js"
export * from "./user_shop_bundle_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports